/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Debt_Fill_TitleInputs */

const vi_lot_debt_fill_title = /** @type {(inputs: Lot_Debt_Fill_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bù đơn đang nợ hàng`)
};

/**

* @param {Lot_Debt_Fill_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_debt_fill_title = /** @type {((inputs?: Lot_Debt_Fill_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Debt_Fill_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_debt_fill_title(inputs)
});